'use client';

import { Link, Text } from '@magicschool/spellbook';
import { FormattedMessage, useIntl } from 'react-intl';
import { analyticsTrack } from '@/util/amplitude/analyticsClient';

export const LegalInfoClient = ({ location }: { location: 'Checkbox' | 'SignUp' | 'SignIn' | 'RoleStep' }) => {
  const intl = useIntl();
  const externalText = intl.formatMessage({ id: 'link.external' });
  return (
    <Text className={location === 'Checkbox' ? '' : 'text-center max-w-xl'}>
      <FormattedMessage
        id={location === 'Checkbox' ? 'auth.agree-to-terms-checkbox' : 'auth.agree-to-terms'}
        values={{
          privacyA: (text) => (
            <Link
              key="privacy"
              href="https://www.magicschool.ai/privacy"
              target="_blank"
              text={{ externalText }}
              onClick={() => {
                analyticsTrack(`${location}:PrivacyTermsClicked`, {
                  value: 'privacy',
                });
              }}
              showExternalIcon={false}
            >
              {text}
            </Link>
          ),
          termsA: (text) => (
            <Link
              key="terms"
              href="https://www.magicschool.ai/privacy-security/terms-of-service"
              target="_blank"
              text={{ externalText }}
              onClick={() => {
                analyticsTrack(`${location}:PrivacyTermsClicked`, {
                  value: 'terms',
                });
              }}
              showExternalIcon={false}
            >
              {text}
            </Link>
          ),
          dpaA: (text) => (
            <Link
              key="dpa"
              href="https://cdn.prod.website-files.com/645187265d5e5e386be40629/6823b388857a84d18480e470_Magic%20School%20-%20TOS%20Student%20Data%20Privacy%20Addendum%20(May%202025).pdf"
              target="_blank"
              text={{ externalText }}
              onClick={() => {
                analyticsTrack(`${location}:DPATermsClicked`, {
                  value: 'dpa',
                });
              }}
              showExternalIcon={false}
            >
              {text}
            </Link>
          ),
        }}
      />
    </Text>
  );
};
